<template>
  <v-row justify="center">
    <v-dialog v-model="BookData.uploadDialog" persistent max-width="500px">
      <v-card class="#FFCD" color="#f9f9f9">
        <v-card-title> {{ $t("mybook.uploadBook") }}</v-card-title>
        <v-form ref="form" lazy-validation class="mr-6 ml-6 pb-6">
          <v-card class="rounded-larg rounded-lg" elevation="3" tile>
            <v-list-item>
              <v-list-item-content class="pl-3">
                <v-row no-gutters>
                  <v-col cols="11">
                    <v-file-input
                      class="fileInputUploadBook"
                      :rules="[rules.required]"
                      :label="$t('mybook.bookFile')"
                      outlined
                      dense
                      required
                      @change="selectBookFile"
                      @keyup.enter="submit"
                    ></v-file-input>
                    
                    <v-text-field class="d-none"></v-text-field>
                  </v-col>
                  <v-col cols="1">
                   <p class="pt-3 mx-2 ">
                      <a target="_blank" href="https://ebook.online-convert.com/convert/zip-to-epub" :title="$t('mybook.convertBook')"><i class="fas fa-external-link-alt"></i></a>
                   </p>
                  </v-col>
                </v-row>
                <v-card-actions class="pa-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    :loading="loadingAdd"
                    @click="BookData.uploadDialog = false"
                    >{{ $t("public.close") }}</v-btn
                  >
                  <v-btn
                    data-cy="submitBTN"
                    color="blue darken-1"
                    text
                    @click="submit"
                    :loading="loadingAdd"
                    >{{ $t("public.continue") }}</v-btn
                  >
                </v-card-actions>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t("valid.required"),
      },
      BookData: this.value,
      loadingAdd: false,
      fileBook: "",
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() != false) {
        this.loadingAdd = true;
        const fd = new FormData();
        fd.append("file", this.fileBook);
        let DataForm = {
          Param: fd,
          API: "/uploader",
        };
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then((responce) => {
            this.loadingAdd = false;
            this.BookData.BookInformation = responce.data.data;
            // this.BookData.meta = responce.data.data.meta;
            this.$router
              .push({
                name: "UploadBook",
                params: {
                  bookData : this.BookData
                },
              })
              .catch(() => {});
          })
          .catch((error) => {
            this.loadingAdd = false;
            this.$store.dispatch("PushErrorMsg", error.data.message);
          });
      } else {
        this.$store.dispatch("PushErrorMsg", this.$t('public.DataNotValid'));
      }
    },
    selectBookFile(file) {
      this.fileBook = file;
    },
  },
};
</script>